// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Menu (Menu.tsx): which of `n` items an arrow key on the trigger opens the
 * list at. ArrowDown enters at the first item, ArrowUp at the last. Returns -1
 * for any other key (or no items), so the caller leaves the event alone —
 * Enter and Space included: they click the trigger natively, and the click
 * opens the list. Disabled items are skipped by the caller (`moveEnabledIndex`).
 */
export function openIndex(key: string, n: number): number {
  if (n <= 0) return -1;
  switch (key) {
    case 'ArrowDown':
      return 0;
    case 'ArrowUp':
      return n - 1;
    default:
      return -1;
  }
}
